<template>
	<div class="service" @click='showMenu'>
		<img class="s-icon" src="@/assets/service-1.png">
		<transition name="slide" mode="out-in">
	        <div v-if='show' class="slide-content" @click.stop>
	        	<div class="item">
	        		<a  href="#/show/help" title="常见问题">
	        			<img src="@/assets/help.png">
	        		</a>
	        	</div>
	        	<div class="item" v-if='isLogin||showAirView'>
	        		<a  @click='showService' title="小多在线" id='ws_service_btn'>
	        			<img style="width:38.82px;height: 42.93px;" src="@/assets/service 2.png">
	        		</a>
	        	</div>
	        	<div class="item" v-if='!isLogin'>
	        		<a  @click='showFeedbackModal=true' title="留言反馈">
	        			<img src="@/assets/feedback.png">
	        		</a>
	        	</div>
	        	<div class="item">
	        		<a  @click='showArticle' title="客服热线">
	        			<img src="@/assets/hotline.png">
	        		</a>
	        	
	        	</div>
	        </div>
	    </transition>
	    <Modal v-model="showModal" footer-hide>
        	<div class="modal-content">
        		<div v-html='modalContent.Content'></div>
        	</div>
	    </Modal>
	    <Robot v-show="showServiceModal" :src='serviceUrl' :visiable='showServiceModal'/>
	    <Modal v-model="showFeedbackModal" title='留言反馈' :styles='{width:"640px",top:"0"}'  footer-hide>
        	<Feedback v-if='showFeedbackModal'/>
	    </Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import Robot from '@/components/common/Robot'
	import Feedback from '@/components/common/Feedback'
	import {baseUrl,udeskUrl} from '@/config/env'
	export default {
		data() {
			return {
				show:false,
				showModal:false,
				serviceUrl:null,
				showAirView:false,
				queryStr:null,
				showServiceModal:false,
				modalContent:{},
				showFeedbackModal:false,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
		},
		mixins:[],
		components: {
			Feedback,
			Robot,
		},
		computed: {
			...mapState({
				userInfo: state => state.common.userInfo,
				token: state => state.common.userToken,
			}),
			isLogin(){
				return this.userInfo?.VipNo && true
			},
			hasPCNo(){
				return this.userInfo?.VipNo && this.userInfo?.VipNo != 'newRegister' && true
			},
		},
		methods: {
			...mapActions([
				'getServiceConfigAction',
				'getCommunityArticleAction',
			]),
			async initData(){
				let visiablePaths = ['/home','/order/product']
				this.showAirView = visiablePaths.includes(this.$route.path)
				// if(!this.token)return
				window.addEventListener('message', e => {
				    let action = e.data.action;
				    if (action == 'showService') {
				    	this.showService()
				    }
				    if (action == 'hideService') {
				    	this.hideService()
				    }
				})
			},
			hideService() {
				this.showServiceModal = false
			},
			async showService(){
				if (!this.serviceUrl) {
					let url = await this.getServiceConfigAction()
					let queryStr = url.replace(/.+\?/,'')
					this.queryStr = queryStr
					this.serviceUrl = baseUrl+'/client/service.html?'+ queryStr
					if (document.body.clientWidth < 680) {
						location = udeskUrl + this.queryStr
					} else {
						setTimeout(()=>{
							this.showServiceModal = true
						},500)
					}
					
					return
				}
				if (document.body.clientWidth < 680) {
					location = udeskUrl + this.queryStr
				} else {
					this.showServiceModal = true
				}
				
			},
			async showArticle(){
				let Code = 'HotLine'
				this.modalContent = await this.getCommunityArticleAction({Code})
				this.showModal = true
			},
			async showMenu(){
				if(this.token) {
					if (!this.hasPCNo) {
						let queryStr = 'web_plugin_id=128171'
						this.queryStr = queryStr
						this.serviceUrl = baseUrl+'/client/service.html?'+ queryStr
					} else {
						let url = await this.getServiceConfigAction()
						let queryStr = url.replace(/.+\?/,'')
						this.queryStr = queryStr
						this.serviceUrl = baseUrl+'/client/service.html?'+ queryStr
					}
				}
				this.show = !this.show;
			},
		},
	}
</script>

<style lang='scss' scoped>
@import '@/style/mixin';
@import '@/style/common';
	.service {
		cursor: pointer;
		z-index: 9999;
		width: 3vw;
		height:11vw;
		min-width: 40px;
		background-color: $theme-color;
		border-radius: 10px;
		.s-icon {
			margin: auto;
			display: block;
			width: 100%;
		}
		img {
			margin: auto;
			display: block;
			margin-bottom: 10px;
			width: 0.25rem;
			min-width:20px;
		}
		.title {
			margin: auto;
			text-align: center;
			@include fontSize($font-size-20);
			writing-mode: tb;
			// font-weight: bold;
			color:white;
		}
	}
	 .slide-enter-active, .slide-leave-active {
		transition: all .5s;
	}
	.slide-enter, .slide-leave-active {
		opacity: 0;
	}
	.slide-content {
		position: absolute;
		cursor: auto;
		bottom: 0;
		left: 3vw;
		width:80px;
		min-height: 100%;
		height:100%;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		background-color: #fff;
		display:flex;
		flex-direction: column;
		overflow: hidden;
		align-items: center;
		justify-content: center;
		box-shadow:15px 2px 20px 1px rgba(0, 0, 0, 0.2);
		.item {
			flex:1;
			display:flex;
			align-items: center;
			justify-content: center;
		}
		a {
			color:#333;
		}
		a:hover {
			color:$theme-color;
		}
	}
	.modal-content {
		margin:20px;
		display:flex;
		flex-direction: column;
		.item {
			display:flex;
			margin:10px 0;
			@include fontSize($font-size-16);
			.label {
				width:100px;
			}
			.value {
				flex:1;
			}
		}
		a {
			color:#333;
		}
		a:hover {
			color:$theme-color;
		}
	}
@media (max-width: 768px){
	.slide-content {
		left:40px;
	}
}
</style>